<template>
  <div class="app flex-row align-items-center">
    <b-dropdown variant="link" no-caret right toggle-class="text-decoration-none p-0" class="theme-switcher-login" menu-class="theme-dropdown-menu">
      <template slot="button-content">
        <i :class="themeIcon" :title="'Tema: ' + themeLabel" style="font-size:1.3rem"></i>
      </template>
      <b-dropdown-header>Tema</b-dropdown-header>
      <b-dropdown-item v-for="t in themes" :key="t.id" @click="setTheme(t.id)" :active="$store.state.theme === t.id">
        <i :class="t.icon" class="mr-2"></i> {{ t.label }}
      </b-dropdown-item>
    </b-dropdown>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <p>
                    <img
                      :src="this.$store.getters.currentLogo"
                      class="img-avatar"
                      alt="Logo" />
                  </p>
                  <h1>Login</h1>
                  <p class="text-muted">Entrar na conta</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="username" type="text" class="form-control" placeholder="Usuário / E-mail" autocomplete="username email" v-on:keyup.enter="loginButton()" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="password" type="password" class="form-control" placeholder="Senha" autocomplete="current-password" v-on:keyup.enter="loginButton()" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="primary" class="px-4" @click="loginButton()" :disabled='loginIsDisabled'>Login</b-button>
                    </b-col>
                  </b-row>


                  <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errormessage && this.errormessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errormessage }}</div>
                  </b-input-group>


                  <b-row>
                    <b-col cols="6">
                      <b-button block class="btn btn-facebook" @click="backToPortal"><span>Portal</span></b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0" @click="passwordForgot()">Esqueceu a senha?</b-button>
                    </b-col>
                  </b-row>

                  <p></p>
                  <!--
                  <small class="text-muted">Versão: {{  this.$store.state.config.version }} | IP: {{ this.ipAddress }}</small>
                  -->
                  <small class="text-muted">Versão: {{  this.$store.state.config.version }}</small>
                </b-form>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%"> -->
              <b-card no-body class="text-white bg-primary py-5 " style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Registrar</h2>
                  <p>Já tem uma conta no Sistema <br>{{ this.$store.state.config.companyName }}?</p>
                  <b-button variant="primary" class="active mt-3" @click="register()">Registre-se agora!</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
  name: 'Login',
  components: {
      Event
    },
  data: function() {
    return {
      ipAddress: '',
      username: '',
      password: '',
      errormessage: '',
      loginIsDisabled: false,

      themes: [
        { id: 'light',     label: 'Claro',     icon: 'fa fa-sun-o' },
        { id: 'dark',      label: 'Escuro',    icon: 'fa fa-moon-o' },
        { id: 'shockwave', label: 'Shockwave', icon: 'fa fa-bolt' },
      ],
    }
  },

  computed: {
    themeIcon() {
      const icons = { light: 'fa fa-sun-o', dark: 'fa fa-moon-o', shockwave: 'fa fa-bolt', bmw: 'fa fa-car' };
      return icons[this.$store.state.theme] || 'fa fa-moon-o';
    },
    themeLabel() {
      const labels = { light: 'Claro', dark: 'Escuro', shockwave: 'Shockwave', bmw: 'BMW' };
      return labels[this.$store.state.theme] || 'Escuro';
    }
  },

  mounted: function() {
    this.getIp()
  },

  methods: {
    setTheme(id) {
      this.$store.commit('SET_THEME', id);
    },

    backToPortal() {
      this.$router.push({ path: '/dashboard' })

    },
    passwordForgot() {
      this.$router.push({ path: '/pages/forgotPassword' })
    },

    

    loginButton() {
      if(this.username == '' && this.password == '') {
        this.errormessage = 'Por favor preencha os campos Usuário e Senha e tente novamente.'
      }
      else
      if(this.username == '') {
        this.errormessage = 'Por favor preencha o campo Usuário e tente novamente.'
      }
      else
      if(this.password == '') {
        this.errormessage = 'Por favor preencha o campo Senha e tente novamente.'
      }
      else {
        this.login();
        
      }
    },

    async getIp() {
      axios.get('https://api.ipify.org?format=json')
        .then(response => {
            this.ipAddress = response.data.ip;
        })
        .catch(error => {
            console.log(error);
        });
    },

    async menu() {
      const cookieMenu = this.$store.state.config.storageName
      var s = this;
      var currentUser = this.$store.state.currentUser;
      
      var url = this.$store.state.ws_url + "/portal/menu?companyId=" +  s.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      console.log("Menu URL: " + url)

      await axios.get(
          url
      )
      .then(function(resp) {
        if(resp.data.obj.length > 0) {          
          localStorage.setItem(cookieMenu + '_MENU',JSON.stringify(resp.data.obj))
          s.$store.commit('SET_MENU', resp.data.obj);
        }
        else {
          s.$store.commit('SET_MENU', [
            {
              name: 'Dashboard',
              url: '/dashboard',
              icon: 'icon-speedometer'
            }
          ])
        }

      })
      .catch(function (error) {
        console.log(error);
      })
     
    },

    async login() {
        const cookieMenu = this.$store.state.config.storageName

        this.errormessage = '';
        var s = this;

        s.errormessage = 'Enviando solicitação de login, aguarde...'
        this.loginIsDisabled = true

        await axios.post(
            this.$store.state.ws_url + "/login",
            {
              "username": this.username,
              "password": this.password,
              "ip": this.ipAddress
            }          
        )
        .then(function(resp) {

          s.$store.commit('SET_CURRENT_USER', resp.data.obj);
          localStorage.setItem(cookieMenu + '_USER',JSON.stringify(resp.data.obj))
          s.$router.push({ path: '/dashboard' });
          s.menu()
        
        })
        .catch(function(error) {
          var errorMessage = "Sem permissão de acesso. Verifique e tente novamente"
          if(error.response && error.response.data && error.response.data.message)
            errorMessage = error.response.data.message

          s.errormessage = errorMessage
          toast ({
              type: VueNotifications.types.error,
              title: 'Login',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 10000
            })
          //return Promise.reject(error)
        })
      
      this.loginIsDisabled = false
      
    },
    register() {
      var registerPage = this.$store.state.config.registerPage
      this.$router.push({ path: registerPage })
      //this.$router.push({ path: '/pages/register' })

    },
  }
}
</script>

<style scoped>
.theme-switcher-login {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
}
</style>
